<div class="modal-header">
  <h4 class="modal-title" translate>
    @if(editContact){
      <span translate>EDIT_CONTACT</span>
    }@else{
      <span translate>CREATE_CONTACT</span>
    }
  </h4>

  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

@if (!editContact) {
  <div class="modal-body" [formGroup]="contactForm">
    <lib-gung-text-input formControlName="firstname" [gungTranslate]="'FIRST_NAME'"></lib-gung-text-input>
    <lib-gung-text-input formControlName="lastname" [gungTranslate]="'LAST_NAME'"></lib-gung-text-input>
    <lib-gung-text-input formControlName="email" [gungTranslate]="'EMAIL'"></lib-gung-text-input>
    <lib-gung-text-input formControlName="phone" [gungTranslate]="'PHONE'"></lib-gung-text-input>

    @if (hubspotPreferences?.length > 0) {
      <lib-gung-input-multi-select
        [optionsList]="hubspotPreferences"
        (selectedValues)="setSelectedValues($event)"
        label="SUBSCRIBE_TO_OPTIONAL"
        [previewField]="['name']">
      </lib-gung-input-multi-select>
    }
  </div>
} @else {
  <div class="modal-body">
    <lib-gung-tabset #ngbTab="gungTabset">
      <lib-gung-tab [title]="'CONTACT' | translate">
        <ng-template libGungTabContent>
          <div [formGroup]="contactForm">
            <lib-gung-text-input formControlName="firstname" [gungTranslate]="'FIRST_NAME'"></lib-gung-text-input>
            <lib-gung-text-input formControlName="lastname" [gungTranslate]="'LAST_NAME'"></lib-gung-text-input>
            <lib-gung-text-input formControlName="email" [gungTranslate]="'EMAIL'"></lib-gung-text-input>
            <lib-gung-text-input formControlName="phone" [gungTranslate]="'PHONE'"></lib-gung-text-input>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab [title]="'SUBSCRIPTIONS' | translate">
        <ng-template libGungTabContent>
          <table class="table table-sm">
            <thead>
              <tr>
                <th translate>SUBSCRIPTION_TYPE</th>
                <th translate>STATUS</th>
                <th translate>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let pref of hubspotPreferences">
                <td>
                  <div class="fw-bold">{{ pref.name }}</div>
                  <small class="text-muted">{{ pref.extra.description }}</small>
                </td>
                <td>
                  <span
                    class="d-inline-flex align-items-center gap-2"
                    [ngClass]="pref.selected ? 'text-success' : 'text-muted'">

                    <i [ngClass]="pref.selected ? 'fas fa-check' : 'fal fa-circle'"></i>

                    {{ pref.selected ? 'Subscribed' : 'Not Specified' }}
                  </span>
                </td>
                <td>
                  <button
                    class="btn btn-sm"
                    [ngClass]="pref.selected ? 'btn-outline-danger' : 'btn-outline-success'"
                    (click)="toggleSubscription(pref)">
                    {{ pref.selected ? 'Unsubscribe' : 'Subscribe' }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  </div>
}

<div class="modal-footer">
  <div class="row w-100">
    <div class="col-12">
      <div class="btn-group btn-group-justified w-100">
        <button class="btn btn-sm btn-outline-secondary btn-default" (click)="activeModal.dismiss()" translate>
          CANCEL
        </button>
        <button class="btn btn-sm btn-primary btn-default" (click)="save($event)" translate>SAVE</button>
      </div>
    </div>
  </div>
</div>
